import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_UNKNOWN: unique symbol = symbolName("unknown");
